import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Size, LogGroup } from "../.././MyHelpers";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { GenericPlusOne, GenericPlusOnePIXIAPP, PlusOneParams } from "./GenericPlusOneAnimation";
import { IPlusOneFactory } from "./IPlusOneFactory";
import { FreegameSpritePlusOne } from "./SpritePlusOneAnimation";
import { FreegameSpritePlusOnePIXIAPP, FreegameSpritePlusOnePIXIAPPResponsive } from "./SpritePlusOneAnimationPIXIAPP";

export class SpritePlusOneFactory implements IPlusOneFactory
{
    public CreatePlusOne(params:PlusOneParams): GenericPlusOne
    {
        return new FreegameSpritePlusOne(params);
    }

    public CreatePlusOnePIXIAPP(params:PlusOneParams): GenericPlusOnePIXIAPP
    {
        return new FreegameSpritePlusOnePIXIAPP(params);
    }

    public CreatePlusOnePIXIAPPResponsive(params:PlusOneParams): GenericPlusOnePIXIAPP
    {
        return new FreegameSpritePlusOnePIXIAPPResponsive(params);
    }
}